import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import mapEcoFormFields from './mapEcoFormFields';
import styles from '../../../styles.module.css';

export const editStyle = {
  display: 'block',
  fontSize: '1.0rem',
  backgroundColor: '#d9fbda',
  border: '2px solid #016722',
  borderRadius: '5px',
  color: '#000000',
  fontWeight: 500,
  fontFamily: 'Segoe UI, sans-serif',
  marginBottom: '2px',
  padding: '2px 6px',
};

export const arrayStyle = {
  width: '50px',
  fontSize: '1.1rem',
  fontWeight: 800,
  fontFamily: 'Segoe UI, sans-serif',
  display: 'block',
  backgroundColor: '#e0f2fe',
  border: '1px solid #60a5fa',
  borderRadius: '5px',
  color: '#1e3a8a',
  marginBottom: '2px',
  padding: '2px 6px',
};

// Única ordem do Enter. Fora dela, o Enter não pula para o próximo campo:
// tipoEco, tipoLaudo, fe3d, tempoEjecaoVE, tempoAEMitral, indiceCardiaco,
// diamSaidaVE, diamAnelPulmonar.
export const ecoSequence = [
  'sexo',
  'idade',
  'peso',
  'altura',
  'superficiecorporea',
  'pressaosistolica',
  'frequenciacardiaca',
  'ecocardiograma',
  'septo',
  'ppve',
  'dd',
  'ds',
  'fraejeBiplanar',
  'achadosDescritivos',
  'contracaoSegmentar',
  'regiaoVE',
  'comentariosDiast',
  'diamAE',
  'indiceVolAE',
  'atrioEsq',
  'valvaMitral',
  'diamAO',
  'valvaAortica',
  'aorta',
  'atrioDireito',
  'veiaCavaInferior',
  'ventriculoDireito',
  'valvaTricuspide',
  'valvaPulmonar',
  'pericardio',
  'areaMitral',
  'gradienteMitral',
  'refluxoMitral',
  'pisaMitral',
  'volumeRegMitral',
  'areaAortica',
  'pisaAortica',
  'refluxoAortica',
  'gmvao',
  'gmvsve',
  'gmvTric',
  'gpit',
  'refluxoTric',
  'gradientePulm',
  'refluxoPulm',
  'gradMitral',
  'refluxoProtMitral',
  'intensidadeProtMitral',
  'gradAortica',
  'refluxoProtAortica',
  'intensidadeProtAortica',
  'gradTricuspide',
  'refluxoProtTricuspide',
  'intensidadeProtTricuspide',
  'gradPulmonar',
  'refluxoProtPulmonar',
  'intensidadeProtPulmonar',
  'valvulopatia',
  'intensidadeValv',
  'predominanciaValv',
  'protese',
  'descProtese',
  'predominanciaProtese',
  'conSeg',
  'regiao',
  'conclusoes',
  'intensidadeConclusoes',
  'observacoes',
];

const floatFields = [
  'peso',
  'altura',
  'superficiecorporea',
  'septo',
  'ppve',
  'dd',
  'ds',
  'fraejeBiplanar',
  'fe3d',
  'tempoEjecaoVE',
  'tempoAEMitral',
  'indiceCardiaco',
  'diamAE',
  'indiceVolAE',
  'diamAO',
  'diamSaidaVE',
  'diamAnelPulmonar',
  'areaMitral',
  'gradienteMitral',
  'pisaMitral',
  'volumeRegMitral',
  'areaAortica',
  'pisaAortica',
  'gmvao',
  'gmvsve',
  'gmvTric',
  'gpit',
  'gradientePulm',
  'gradMitral',
  'gradAortica',
  'gradTricuspide',
  'gradPulmonar',
];

const codes = size => Array(size).fill('');

export function emptyEcoForm() {
  return {
    codEco: '',
    tipoLaudo: 'Alterado',
    tipoEco: '',
    sexo: '',
    idade: '',
    peso: '',
    altura: '',
    superficiecorporea: '',
    pressaosistolica: '',
    frequenciacardiaca: '',
    ecocardiograma: codes(10),
    septo: '',
    ppve: '',
    dd: '',
    ds: '',
    fraejeBiplanar: '',
    fe3d: '',
    achadosDescritivos: codes(10),
    contracaoSegmentar: codes(10),
    regiaoVE: codes(10),
    tempoEjecaoVE: '',
    tempoAEMitral: '',
    indiceCardiaco: '',
    comentariosDiast: codes(10),
    diamAE: '',
    indiceVolAE: '',
    atrioEsq: codes(5),
    valvaMitral: codes(5),
    diamAO: '',
    diamSaidaVE: '',
    valvaAortica: codes(5),
    aorta: codes(5),
    atrioDireito: codes(5),
    veiaCavaInferior: codes(5),
    ventriculoDireito: codes(5),
    valvaTricuspide: codes(5),
    valvaPulmonar: codes(5),
    diamAnelPulmonar: '',
    pericardio: codes(10),
    areaMitral: '',
    gradienteMitral: '',
    refluxoMitral: codes(5),
    pisaMitral: '',
    volumeRegMitral: '',
    areaAortica: '',
    pisaAortica: '',
    gmvao: '',
    gmvsve: '',
    refluxoAortica: codes(5),
    gmvTric: '',
    gpit: '',
    refluxoTric: codes(5),
    refluxoPulm: codes(5),
    gradientePulm: '',
    gradMitral: '',
    refluxoProtMitral: codes(5),
    intensidadeProtMitral: codes(5),
    gradAortica: '',
    refluxoProtAortica: codes(5),
    intensidadeProtAortica: codes(5),
    gradTricuspide: '',
    refluxoProtTricuspide: codes(5),
    intensidadeProtTricuspide: codes(5),
    gradPulmonar: '',
    refluxoProtPulmonar: codes(5),
    intensidadeProtPulmonar: codes(5),
    valvulopatia: codes(5),
    intensidadeValv: codes(5),
    predominanciaValv: codes(5),
    protese: codes(5),
    descProtese: codes(5),
    predominanciaProtese: codes(5),
    conSeg: codes(5),
    regiao: codes(5),
    conclusoes: codes(10),
    intensidadeConclusoes: codes(10),
    observacoes: '',
  };
}

export function calcSuperficie(peso, altura) {
  const p = parseFloat(String(peso ?? '').replace(/,/g, '.'));
  const a = parseFloat(String(altura ?? '').replace(/,/g, '.'));
  if (!p || !a) return '';
  return (0.007184 * (a * 100) ** 0.725 * p ** 0.425).toFixed(2);
}

export function buildHydratedForm(eco) {
  const mapped = mapEcoFormFields(eco);
  return {
    ...emptyEcoForm(),
    ...mapped,
    codEco: eco.CODECO || '',
    idade: eco.idadePAC || '',
    tipoEco: eco.TIPOECO || '',
    superficiecorporea:
      calcSuperficie(mapped.peso, mapped.altura) || eco.SUPCORP || '',
  };
}

export function applyCopiedEco(prev, ecoSelected) {
  const mapped = mapEcoFormFields(ecoSelected);
  return {
    ...prev,
    ...mapped,
    codEco: prev.codEco,
    idade: prev.idade,
    tipoEco: prev.tipoEco,
    superficiecorporea:
      calcSuperficie(mapped.peso, mapped.altura) || prev.superficiecorporea,
  };
}

export function normalizeFloatFields(data) {
  const result = { ...data };
  floatFields.forEach(field => {
    if (typeof result[field] === 'string') {
      const clean = result[field].replace(/,/g, '.');
      result[field] = clean === '' ? null : parseFloat(clean);
    }
  });
  return result;
}

export function blockEnter(e) {
  if (e.key === 'Enter') e.preventDefault();
}

export function codeInputId(field, index) {
  return `${field}-${index}`;
}

export function focusEcoInput(id) {
  if (!id) return null;
  const node = document.getElementById(id);
  if (!node) return null;
  node.focus();
  return node;
}

export function legendFor(values, savedItems, codeKey, textKey) {
  return (values || [])
    .map((value, index) => {
      if (value === '' || value == null) return null;
      const saved = savedItems?.[index];
      const matches = saved && String(saved[codeKey]) === String(value);
      return {
        index,
        code: value,
        text: matches ? saved[textKey] || 'Descrição não encontrada' : null,
      };
    })
    .filter(Boolean);
}

export function MeasureField({
  name,
  label,
  value,
  onChange,
  onKeyDown,
  readOnly = false,
  layout = 'stack',
  labelCol = 2,
}) {
  const control = (
    <Form.Control
      name={name}
      value={value ?? ''}
      onChange={onChange}
      onKeyDown={onKeyDown}
      style={readOnly ? undefined : editStyle}
      type="text"
      inputMode={readOnly ? undefined : 'decimal'}
      size="sm"
      readOnly={readOnly}
      autoComplete="off"
    />
  );

  if (layout === 'inline') {
    return (
      <Form.Group as={Row} className="mb-0" controlId={name}>
        <Form.Label column sm={labelCol}>
          {label}
        </Form.Label>
        <Col sm={4}>{control}</Col>
      </Form.Group>
    );
  }

  return (
    <Form.Group controlId={name} className="mb-0">
      <Form.Label>{label}</Form.Label>
      {control}
    </Form.Group>
  );
}

export function CodeArrayField({
  label,
  field,
  values,
  savedItems,
  codeKey,
  textKey,
  onChange,
  onKeyDown,
  onClear,
  hideLabel = false,
}) {
  const legends = legendFor(values, savedItems, codeKey, textKey);
  const accessibleName = label || field;

  return (
    <>
      {label && !hideLabel ? <Form.Label>{label}</Form.Label> : null}
      <div className="d-flex flex-wrap gap-1">
        {(values || []).map((val, i) => (
          <Form.Control
            key={i}
            id={codeInputId(field, i)}
            size="sm"
            style={arrayStyle}
            value={val ?? ''}
            inputMode="numeric"
            aria-label={`${accessibleName} ${i + 1}`}
            onChange={e => onChange(e, field, i)}
            onKeyDown={e => onKeyDown(e, field, i)}
            autoComplete="off"
          />
        ))}
        <Button
          type="button"
          variant="outline-danger"
          size="sm"
          style={{ marginLeft: 4, padding: '0 6px', height: 30 }}
          onClick={() => onClear(field)}
          tabIndex={-1}
          aria-label={`Limpar ${accessibleName}`}
        >
          ×
        </Button>
      </div>
      {legends.map(item => (
        <span key={item.index} className={styles.spanStyle}>
          {item.text ? `[ ${item.code} — ${item.text} ]` : `[ ${item.code} ]`}
        </span>
      ))}
    </>
  );
}
